import React from "react";
import {
  Grid,
  Button,
  MenuItem,
  Select,
  TextField,
  Stack,
  Typography,
} from "@mui/material";
import CustomExpandMore from "../../../../common/CustomExpandMore";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import { useStyles } from "../styles";

const FeesSchema = Yup.object().shape({
  amount: Yup.string()
    .required("* Please enter Amount")
    .matches(/^0*[1-9]\d*$/, "Please enter valid number"),
});

const EditFeesManagement = (props) => {
  const classes = useStyles();

  const initValues = {
    amount: "10000",
  };

  return (
    <Grid container sx={{ p: 3 }} className={classes.feesList}>
      <Grid item lg={4} sm={12}>
        {/* <Stack direction="row" alignItems="center" gap={1}>
          <ArrowBackIosIcon className={classes.backArrow} onClick={back} />
          <Typography
            variant="body1"
            className={classes.backArrow}
            onClick={back}
          >
            Back
          </Typography>
        </Stack>
        <br /> */}
        <Stack className={classes.align}>
          <Formik
            validationSchema={FeesSchema}
            initialValues={initValues}
            validateOnBlur={false}
            validateOnChange={false}
            onSubmit={(values) => {}}
          >
            {(formik) => {
              const {
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                values,
              } = formik;
              return (
                <form onSubmit={handleSubmit}>
                  <Stack>
                    <Typography className={classes.title} sx={{ pb: 2 }}>
                      Add Fee
                    </Typography>
                  </Stack>
                  <Stack className={classes.formView}>
                    <Typography className={classes.input_label}>
                      Fee type
                    </Typography>
                    <Select
                      id="type"
                      name="type"
                      placeholder="Choose Fee Type"
                      IconComponent={CustomExpandMore}
                      sx={{
                        width: 220,
                      }}
                    >
                      <MenuItem value="jeep">Jeep</MenuItem>
                      <MenuItem value="volkswagen">Volkswagen</MenuItem>
                      <MenuItem value="volvo">Volvo</MenuItem>
                      <MenuItem value="jaguar">Jaguar</MenuItem>
                      <MenuItem value="audi">Audi</MenuItem>
                    </Select>
                  </Stack>
                  <br />
                  <Stack className={classes.formView}>
                    <Typography className={classes.input_label}>
                      Amount
                    </Typography>
                    <TextField
                      id="amount"
                      name="amount"
                      // placeholder="Enter Title"
                      className={
                        errors.amount && touched.amount
                          ? classes.inputError
                          : classes.inputNoError
                      }
                      onChange={handleChange}
                      value={values.amount}
                    />
                    <ErrorMessage
                      name="amount"
                      component="span"
                      className={classes.error}
                    />
                  </Stack>
                  <br />
                  <Stack className={classes.formView}>
                    <Typography className={classes.input_label}>
                      Department
                    </Typography>
                    <Select
                      id="department"
                      name="department"
                      placeholder="Choose Department"
                      IconComponent={CustomExpandMore}
                      sx={{
                        width: 220,
                      }}
                    >
                      <MenuItem value="jeep">Jeep</MenuItem>
                      <MenuItem value="volkswagen">Volkswagen</MenuItem>
                      <MenuItem value="volvo">Volvo</MenuItem>
                      <MenuItem value="jaguar">Jaguar</MenuItem>
                      <MenuItem value="audi">Audi</MenuItem>
                    </Select>
                  </Stack>
                  <br />
                  <Stack className={classes.formView}>
                    <Typography className={classes.input_label}>
                      Year
                    </Typography>
                    <Select
                      id="year"
                      name="year"
                      placeholder="Choose Year"
                      IconComponent={CustomExpandMore}
                      sx={{
                        width: 220,
                      }}
                    >
                      <MenuItem value="jeep">Jeep</MenuItem>
                      <MenuItem value="volkswagen">Volkswagen</MenuItem>
                      <MenuItem value="volvo">Volvo</MenuItem>
                      <MenuItem value="jaguar">Jaguar</MenuItem>
                      <MenuItem value="audi">Audi</MenuItem>
                    </Select>
                  </Stack>
                  <br />
                  <Stack className={classes.formView}>
                    <Typography className={classes.input_label}>
                      Semester
                    </Typography>
                    <Select
                      id="semester"
                      name="semester"
                      placeholder="Choose Semester"
                      IconComponent={CustomExpandMore}
                      sx={{
                        width: 220,
                      }}
                    >
                      <MenuItem value="jeep">Jeep</MenuItem>
                      <MenuItem value="volkswagen">Volkswagen</MenuItem>
                      <MenuItem value="volvo">Volvo</MenuItem>
                      <MenuItem value="jaguar">Jaguar</MenuItem>
                      <MenuItem value="audi">Audi</MenuItem>
                    </Select>
                  </Stack>
                  <br />
                  <Stack className={classes.twoButtons}>
                    <Button
                      type="close"
                      sx={{
                        width: "40%",
                        px: 1,
                        py: 2,
                        borderRadius: "50px",
                        fontSize: "15px",
                      }}
                      className={classes.cancel_btn}
                    >
                      Close
                    </Button>
                    <Button
                      type="submit"
                      sx={{
                        width: "40%",
                        px: 1,
                        py: 2,
                        borderRadius: "50px",
                        fontSize: "15px",
                      }}
                      className={classes.submit_btn}
                    >
                      Add Fee
                    </Button>
                  </Stack>
                </form>
              );
            }}
          </Formik>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default EditFeesManagement;
